import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins, standardColours } from '../styles';
import { Container, Heading, Button } from './ui';

const StyledTextCta = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  background-color: ${standardColours.lightGrey};

  ${minBreakpointQuery.tiny`
    display: flex;
    flex-direction: column;
  `}

  ${minBreakpointQuery.medium`
    flex-direction: row;
  `}
`;

const StyledHeading = styled(Heading)`
  padding: 40px 30px;
  line-height: 1.5;

  ${minBreakpointQuery.small`
    padding-top: 50px;
    padding-bottom: 50px;
  `}

  ${minBreakpointQuery.medium`
    padding-right: 50px;
    padding-left: 50px;
  `}

  ${minBreakpointQuery.large`
    padding: 60px;
  `}

  ${minBreakpointQuery.xlarge`
    padding: 70px;
  `}
`;

const StyledButton = styled(Button)`
  width: 100%;

  ${minBreakpointQuery.tiny`
    margin-top: auto;
    margin-left: auto;
    width: 280px;
  `}

  ${minBreakpointQuery.medium`
    min-width: 280px;
  `}
`;

const TextCta = ({ heading, link }) => (
  <StyledTextCta>
    <Container>
      <StyledInner>
        <StyledHeading alt={true}>{heading}</StyledHeading>
        <StyledButton to={link.page} alt={true}>
          {link.text}
        </StyledButton>
      </StyledInner>
    </Container>
  </StyledTextCta>
);

export default TextCta;
